// extracted by mini-css-extract-plugin
module.exports = {"SettingsContent":"security_SettingsContent__3Qc6i","SecurityModule":"security_SecurityModule__2VvYE","WarningText":"security_WarningText__2FfgK","Modal":"security_Modal__1GBbi"};